<ebs-unity-web-vr [gameConfiguration] = "gameConfiguration"></ebs-unity-web-vr>
